import {Patient} from '@cypro/engine/schema'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {Box, Button} from '@chakra-ui/react'
import {useCan} from '@/shared/hooks/use-permissions'
import {useTranslate} from '@tolgee/react'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {dialog} from '@cypro/ui/components'
import {useMemo} from 'react'
import {getFullName} from '@/modules/users/functions'
import {isPendingHl7Import} from '@/modules/patients/functions'
import {AdminCareDialog} from '../../dialogs/admin-care-dialog'

export function AdminAndCare({patient}: {patient: Patient}) {
  const {t} = useTranslate('common')
  const canEditPatient = useCan('patients.edit')
  const latest = patient.encounters?.[0]

  const items = useMemo(
    () => [
      {
        label: t('responsible_doctor'),
        value: getFullName(patient.responsibleDoctor, 'last-first') || '-',
      },
      {
        label: t('family_doctor'),
        value: patient.familyDoctor?.name || '-',
      },
      {
        label: t('section'),
        value: latest?.section?.name || '-',
      },
      {
        label: t('ward'),
        value: latest?.ward?.name || '-',
      },
      {
        label: t('customer_of'),
        value: latest?.customer?.name || '-',
      },
      {
        label: t('ambulatory'),
        value: latest?.ambulatory ? t('yes') : t('no'),
      },
    ],
    [t, patient.responsibleDoctor, patient.familyDoctor, latest]
  )

  return (
    <Box rounded="md" borderWidth="1px" padding="4">
      <DataSection
        label={
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            {t('patient.encounters')}
            <Button
              variant="ghost"
              colorPalette="cyan"
              disabled={!canEditPatient || isPendingHl7Import(patient)}
              onClick={async () => {
                await dialog.open('patient-admin-care', {
                  children: (
                    <AdminCareDialog
                      patientId={patient.id}
                      responsibleDoctorId={patient.responsibleDoctorId}
                      familyDoctorId={patient.familyDoctorId}
                      adminDetails={latest}
                    />
                  ),
                })
              }}
            >
              {t('edit')}
            </Button>
          </Box>
        }
      >
        <DataList items={items} />
      </DataSection>
    </Box>
  )
}
